import { instance } from '../../../services/api';

export default (bookingFileId: number) => instance.get(`/api/driverEvaluations/${bookingFileId}`);